import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'removeHtml'
})
export class RemoveHtmlPipe implements PipeTransform {
	/**
	 * Retire les balises par manipulation de chaîne, et non via `document.createElement` :
	 * les pipes sont évalués pendant le rendu SSR, où `document` n'existe pas. Une seule
	 * implémentation pour le serveur et le navigateur évite aussi tout écart à l'hydratation.
	 */
	transform(value: string): string {
		if (!value) return '';

		return value
			.replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, '')
			.replace(/<[^>]*>/g, '')
			.replace(/\s+/g, ' ')
			.trim();
	}
}
